import { render } from "./CartDrawerDivider.vue?vue&type=template&id=984a9cda"
import script from "./CartDrawerDivider.vue?vue&type=script&lang=js"
export * from "./CartDrawerDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__